import * as L from 'leaflet';

/**
 * Devuelve un conjunto de capas base (`L.TileLayer`) que se pueden usar
 * como fondos para un mapa Leaflet. Incluye OpenStreetMap y distintos estilos
 * de Google Maps (terreno, híbrido, calles, satélite).
 *
 * Cada capa base representa un estilo visual distinto del mapa, ideal para
 * usarse junto a controles como `L.control.layers()` para que el usuario pueda
 * alternar entre ellas.
 *
 * @returns Un objeto con claves descriptivas y valores `L.TileLayer` listos para usar.
 */
export function getBaseLayers(): {
  OpenStreetMap: L.TileLayer;
  GoogleTerrain: L.TileLayer;
  GoogleHybrid: L.TileLayer;
  GoogleStreets: L.TileLayer;
  GoogleSatellite: L.TileLayer;
} {
  const attribution =
    '&copy; <a href="https://gltracker.pe/" target="_blank" rel="noreferrer noopener">GL Tracker</a>';

  const osm = L.tileLayer(
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    {
      minZoom: 4,
      maxZoom: 18,
      attribution,
    }
  );

  const googleOptions = {
    minZoom: 4,
    maxZoom: 21,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution,
  };

  const googleTerrain = L.tileLayer(
    'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
    googleOptions
  );
  const googleHybrid = L.tileLayer(
    'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    googleOptions
  );
  const googleStreets = L.tileLayer(
    'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    googleOptions
  );
  const googleSatellite = L.tileLayer(
    'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    googleOptions
  );

  return {
    OpenStreetMap: osm,
    GoogleTerrain: googleTerrain,
    GoogleHybrid: googleHybrid,
    GoogleStreets: googleStreets,
    GoogleSatellite: googleSatellite,
  };
}
